import PhotoSwipe from './photoswipe';
import PhotoSwipeUI_Default from './photoswipe-ui-default';

let pswpElement = document.querySelectorAll('.pswp')[0];
$('[data-gallery]').click(function() {
	let $c = $(this),
		items = $c.data('gallery');
	
	// define options (if needed)
	let options = {
		// optionName: 'option value'
		// for example:
		index: 0 // start at first slide
	};
	// Initializes and opens PhotoSwipe
	let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
	gallery.init();
});
